import { useProviderActivePatientsQuery } from '@uplift/queries';
import React from 'react';


export const usePatients = (providerId: string) => {
  const { data } = useProviderActivePatientsQuery(providerId);

  const patients = React.useMemo(() => {
    if (!data) {
      return [];
    }

    return data.map(({ user, profile }) => ({
      id: user.id,
      firstName: user.firstName,
      lastName: user.lastName,
      preferredName: profile.preferredName ?? '',
    }));
  }, [ data ]);

  return patients;
};
